import { z } from "zod"

import { portalSigninLinkFailureReasons } from "../../portal-signin-links.js"

/** 32 bytes, base64url, no padding: the HMAC of the send that carried it,
    or random for a link sent to replace an expired one. */
export const PortalSigninTokenSchema = z.string().regex(/^[A-Za-z0-9_-]{43}$/)

/** The client link the page was opened on, and the token from the email.
    Used to exchange the token, to ask for a new link, and to ask for a code
    once the link is used. */
export const PortalSigninLinkBodySchema = z.object({
  /* A token, or `slug:<client-slug>` for a readable link. */
  linkToken: z.string().min(3).max(256),
  signinToken: PortalSigninTokenSchema,
})

export type PortalSigninLinkBody = z.infer<typeof PortalSigninLinkBodySchema>

/** Verify a code that was sent to the address behind a used link. */
export const PortalSigninLinkVerifyCodeBodySchema =
  PortalSigninLinkBodySchema.extend({
    challengeId: z.string().uuid(),
    code: z.string().regex(/^\d{6}$/),
  })

/** Why a link did not sign the client in. The address is masked, and only
    set for a used or expired link: an invalid token names no one. */
export const PortalSigninLinkFailureSchema = z.object({
  error: z.object({
    code: z.literal("signin_link_failed"),
    message: z.string(),
    reason: z.enum(portalSigninLinkFailureReasons),
    maskedEmail: z.string().nullable(),
  }),
})

export type PortalSigninLinkFailure = z.infer<
  typeof PortalSigninLinkFailureSchema
>["error"]

export const PortalSigninLinkReissueResponseSchema = z.object({
  message: z.string(),
})
